angular.module('env.customConfig.logicResolvers', ['env.customConfig.provider'])

    /**
     * Holds a set of common methods used to calculate a proper name prefix for a customised resources
     * depending on the resources existence, current user, step information or any other supplied data via context.
     */
    .provider('$customLogicResolvers', function CustomLogicResolvers() {

        var injector = angular.injector(["ng"]);
        var http = injector.get("$http");
        var log = injector.get("$log");

        this.$get = function () {
            return new CustomLogicResolvers();
        };

        /**
         * Resolves URI to the specified customised resource based on the logic to form the name of the resource
         * using prefixes to indicate how the resource relates to centre or customer users, steps, centre code, etc.
         */
        this.resolveResourceUri = function (context, resourceName) {

            //Calculate the prefix based on the following logic. Then finds the corresponding
            //resource in the server's resource index file and returns the full URI to the resource.
            //
            //Centre users:
            //1. <Centre.Code>_<configured Step string>_additional-fields.html
            //2. _<configured Step string>_additional-fields.html
            //3. <Centre.Code>_general_additional-fields.html
            //4. _general_additional-fields.html
            //
            //Customer users:
            //1. Customer_<Centre.Code>_<configured Step string>_additional-fields.html
            //2. Customer__<configured Step string>_additional-fields.html
            //3. Customer_<Centre.Code>_general_additional-fields.html
            //4. Customer__general_additional-fields.html
            //
            //--> if none of these file names resolve to a valid file in the server's 'customise' folder, 
            //try the 'centre user' named files in the order listed above using the %user%.Customer.Centre 
            //as the Id to locate the Centre.Code for use in the template name.

            //Context object will be of the form: { user: %currentUserObject%, step: %stepCode% }
            var resourceUri = resourceName;
            if (!context) {
                return resourceUri;
            }

            var prefixes = [];
            var user = context.user;
            var step = context.step || "";
            var code = "";
            var isCustomer = user && user.role.isCustomer;
            var resourcesMap = context.customResourcesMap;

            if (user && user.role.isCentre && user.centres && user.centres.length > 0) {
                code = user.centres[0].code;
            } else if (user && user.customers && user.customers.length > 0) {
                code = user.customers[0].centreCode;
            }

            var addPossiblePrefixesToArray = function (array, customerPrefix) {
                if (code && step) {
                    array.push(_.string.sprintf("%s%s_%s_", customerPrefix ? customerPrefix : "", code, step));
                }
                if (step) {
                    array.push(_.string.sprintf("%s_%s_", customerPrefix ? customerPrefix : "", step));
                }
                if (code) {
                    array.push(_.string.sprintf("%s%s_general_", customerPrefix ? customerPrefix : "", code));
                }

                array.push(_.string.sprintf("%s_general_", customerPrefix ? customerPrefix : ""));
            };

            //Add all possible prefixes to the array to find out later what prefix is topmost 
            //and corresponds to the available customised resource on the server.
            //If user is a customer user - try with the 'customer_' prefix first.
            if (isCustomer) {
                addPossiblePrefixesToArray(prefixes, "Customer_"); //customer users targeted resources prefixes
            }
            addPossiblePrefixesToArray(prefixes); //centre users targeted resources prefixes
            prefixes.push(""); //and finally push empty prefix for the case when resource used without a prefix at all

            for (var i = 0; i < prefixes.length; ++i) {
                var p = prefixes[i];
                var prefixFoundOnServer = _.find(resourcesMap, function (resource) {
                    return _.string.endsWith(resource, _.string.sprintf("/%s%s", p, resourceName));
                });
                if (prefixFoundOnServer) {
                    resourceUri = prefixFoundOnServer;
                    break;
                }
            }

            //log.debug(_.string.sprintf("Resolved URI for customised resource [%s] to: %s", resourceName, resourceUri));

            //return the full path to the resource as it stated in the resources map on the server
            return resourceUri;
        };

        /**
         * Tries to resolve the uri to the configuration file and then to download and evaluate it.
         * If succeeded, the resulted configuration object as a proper javascript object instance will be returned.
         */
        this.resolveConfigFromServer = function (context, configName, defaultConfigObject) {
            //Context object will be of the form: { user: %currentUserObject%, step: %stepCode% }

            //Resolve URI of the config js file on the server
            var configUri = this.resolveResourceUri(context, configName);

            //Try to download it and evaluate
            if (configUri) {
                return http.get(configUri).then(function (resp) {
                        // this callback will be called asynchronously
                        // when the response is available
                        log.debug(_.string.sprintf("Successfully downloaded config [%s] from server [%s].", configName, configUri));
                        //Now try to construct the config object and return it
                        var config = null;
                        try {
                            config = eval(resp.data);
                        } catch (e) {
                            config = defaultConfigObject;
                            log.error(_.string.sprintf("Error while constructing config object [%s] downloaded from [%s]. %s", configName, configUri, e));
                        }
                        return config || defaultConfigObject;
                    },
                    function (resp) {
                        // called asynchronously if an error occurs
                        // or server returns response with an error status.
                        log.error(_.string.sprintf("Can not download config [%s] from server [%s]. Details: %s %s.", configName, configUri, resp.status, resp.statusText));
                        return defaultConfigObject;
                    });
            } else {
                //otherwise just return null object
                return null;
            }
        };

    });
